(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("assignmentLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/assignmentLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessAssignmentResource", "FILE_FORMATS", "$state", "messageService", "$uibModal", "frameworkService", "Upload", "$timeout", AssignmentLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function AssignmentLearnerAccessCtrl(assignmentLearnerAccessAssignmentResource, FILE_FORMATS, $state, messageService, $uibModal, frameworkService, Upload, $timeout) {
        var vm = this;
        vm.number = $state.params.number;
        vm.version = $state.params.version;
        vm.code = $state.params.code;
        vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
        vm.maxFilesAllowed = 1;
        vm.acceptedFiles = FILE_FORMATS.assignment;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.parentCtrl.requalifyClicked = false;
            vm.parentCtrl.contentLoaded = false;
            vm.assignmentCompletedOrExpired = vm.assignment.assignmentStatus === 4 || vm.assignment.assignmentStatus === 3;
            load();
        };
        /////////////////////////////////////////////////////////////////////
        function load() {
            assignmentLearnerAccessAssignmentResource.get({ id: vm.assignment.id }, function (result) {
                vm.model = result;
                //expired or expiring
                if (vm.assignment.assignmentStatus === 4 || vm.assignment.expiring)
                    setupRequalifyButton();
                vm.parentCtrl.contentLoaded = true;
            }, function (error) {
                messageService.error(error);
            });
        }
        function setupRequalifyButton() {
            vm.parentCtrl.buttons = "requalifyButton";
            vm.parentCtrl.requalify = vm.requalify;
        }
        vm.requalify = function () {
            vm.parentCtrl.requalifyClicked = true;
            vm.assignment.$requalify({ number: vm.number, version: vm.version, code: vm.code }, function () {
                $state.reload();
                //$state.go("main.learningPath.learningItemModal", { number: vm.number, version: vm.version, code: vm.code });
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.viewInstructions = function () {
            $uibModal.open({
                templateUrl: "instructions.html",
                controller: ["data", function (data) {
                        var vm = this;
                        vm.instructions = data.instructions;
                    }],
                controllerAs: "vm",
                animation: false,
                resolve: {
                    data: vm.model
                }
            }).result.catch(angular.noop);
        };
        vm.viewAsHtml = function (text, title) {
            $uibModal.open({
                templateUrl: "instructions.html",
                controller: ["data", function (data) {
                        var vm = this;
                        vm.body = data.modelBody;
                        vm.title = data.modalTitle;
                    }],
                controllerAs: "vm",
                animation: false,
                resolve: {
                    data: function () {
                        return { modalTitle: title, modelBody: text };
                    }
                }
            }).result.catch(angular.noop);
        };
        vm.uploadFile = function (file, url) {
            if (file) {
                vm.saving = true;
                file.upload = Upload.upload({
                    url: url,
                    data: {
                        file: file
                    }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        //if (response.data.length > 0) {
                        vm.model = response.data;
                        messageService.success("common.dropzone.uploadedFileMessage");
                        vm.progress = 0;
                        vm.saving = false;
                        //}
                    });
                }, function (response) {
                    messageService.error(response);
                    vm.progress = 0;
                    vm.saving = false;
                }, function (evt) {
                    file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
        vm.upload = function (file) {
            var url = "api/assignmentAssignments/" + vm.assignment.id + "/learnerAccess/uploadAssignmentDocument";
            vm.uploadFile(file, url);
        };
        vm.replace = function (file) {
            var url = "api/assignmentAssignments/" + vm.assignment.id + "/learnerAccess/replaceAssignmentDocument";
            vm.uploadFile(file, url);
        };
        vm.submit = function () {
            vm.submitting = true;
            assignmentLearnerAccessAssignmentResource.submitAssignment({ id: vm.assignment.id }, function (result) {
                vm.model = result;
                messageService.success("learningItem.learnerAccess.assignment.submitSuccess");
                vm.submitting = false;
            }, function (error) {
                messageService.error(error);
                vm.submitting = false;
            });
        };
    }
}());
